export const data = [
  {
    room: 'A102 - 1F-A - DETS Sonapur - DETS',
    short: 'A102',
    powerAverage: 1.18,
    'elec/therm': 2.89,
    volume: '',
    elec: 131.85,
    hours: 112,
    therm: 45.55,
    estimateKWh: 9017.3
  },
  {
    room: 'A006 - GF-A - DETS Sonapur - DETS',
    short: 'A006',
    powerAverage: 0.78,
    'elec/therm': 1.72,
    volume: '',
    elec: 104.48,
    hours: 134,
    therm: 60.67,
    estimateKWh: 7145.1
  },
  {
    room: 'B020 - GF-B - DETS Sonapur - DETS',
    short: 'B020',
    powerAverage: 1.08,
    'elec/therm': 0.7,
    volume: '',
    elec: 87.83,
    hours: 81,
    therm: 125.87,
    estimateKWh: 6006.74
  },
  {
    room: 'A101 - 1F-A - DETS Sonapur - DETS',
    short: 'A101',
    powerAverage: 0.69,
    'elec/therm': 1.29,
    volume: '',
    elec: 80.18,
    hours: 117,
    therm: 62.25,
    estimateKWh: 5483.21
  },
  {
    room: 'A122 - 1F-A - DETS Sonapur - DETS',
    short: 'A122',
    powerAverage: 1.13,
    'elec/therm': 3.19,
    volume: '',
    elec: 75.52,
    hours: 67,
    therm: 23.7,
    estimateKWh: 5164.72
  },
  {
    room: 'B204 - 2F-B - DETS Sonapur - DETS',
    short: 'B204',
    powerAverage: 0.67,
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 74.41,
    hours: 111,
    therm: 0,
    estimateKWh: 5089.15
  },
  {
    room: 'B207 - 2F-B - DETS Sonapur - DETS',
    short: 'B207',
    powerAverage: 0.69,
    'elec/therm': 0.93,
    volume: '',
    elec: 72.91,
    hours: 105,
    therm: 78.11,
    estimateKWh: 4986.63
  },
  {
    room: 'A111 - 1F-A - DETS Sonapur - DETS',
    short: 'A111',
    powerAverage: 1.03,
    'elec/therm': 2.77,
    volume: '',
    elec: 70,
    hours: 68,
    therm: 25.25,
    estimateKWh: 4787.54
  },
  {
    room: 'B201 - 2F-B - DETS Sonapur - DETS',
    short: 'B201',
    powerAverage: 0.77,
    'elec/therm': 0.5,
    volume: '',
    elec: 68.14,
    hours: 89,
    therm: 135.73,
    estimateKWh: 4660.34
  },
  {
    room: 'B210 - 2F-B - DETS Sonapur - DETS',
    short: 'B210',
    powerAverage: 0.77,
    'elec/therm': 0.79,
    volume: '',
    elec: 66.61,
    hours: 86,
    therm: 84.17,
    estimateKWh: 4555.77
  },
  {
    room: 'B203 - 2F-B - DETS Sonapur - DETS',
    short: 'B203',
    powerAverage: 0.58,
    'elec/therm': 0.64,
    volume: '',
    elec: 66.23,
    hours: 114,
    therm: 103.09,
    estimateKWh: 4529.23
  },
  {
    room: 'B019 - GF-B - DETS Sonapur - DETS',
    short: 'B019',
    powerAverage: 0.75,
    'elec/therm': 1.37,
    volume: '',
    elec: 66.05,
    hours: 88,
    therm: 48.2,
    estimateKWh: 4516.85
  },
  {
    room: 'B112 - 1F-B - DETS Sonapur - DETS',
    short: 'B112',
    powerAverage: 0.78,
    'elec/therm': 1.76,
    volume: '',
    elec: 65.79,
    hours: 84,
    therm: 37.39,
    estimateKWh: 4499.62
  },
  {
    room: 'B215 - 2F-B - DETS Sonapur - DETS',
    short: 'B215',
    powerAverage: 0.59,
    'elec/therm': 0.63,
    volume: '',
    elec: 65.76,
    hours: 112,
    therm: 104.07,
    estimateKWh: 4497.43
  },
  {
    room: 'B214 - 2F-B - DETS Sonapur - DETS',
    short: 'B214',
    powerAverage: 0.45,
    'elec/therm': 0.63,
    volume: 1.03884393612225,
    elec: 65.73,
    hours: 146,
    therm: 103.64,
    estimateKWh: 4495.52
  },
  {
    room: 'B024 - GF-B - DETS Sonapur - DETS',
    short: 'B024',
    powerAverage: 0.71,
    'elec/therm': 0.65,
    volume: 1.12275747875539,
    elec: 63.6,
    hours: 89,
    therm: 97.78,
    estimateKWh: 4349.91
  },
  {
    room: 'B212 - 2F-B - DETS Sonapur - DETS',
    short: 'B212',
    powerAverage: 0.68,
    'elec/therm': 0.41,
    volume: '',
    elec: 63.03,
    hours: 93,
    therm: 152.51,
    estimateKWh: 4310.86
  },
  {
    room: 'B122 - 1F-B - DETS Sonapur - DETS',
    short: 'B122',
    powerAverage: 0.83,
    'elec/therm': 0.84,
    volume: '',
    elec: 61.27,
    hours: 74,
    therm: 72.94,
    estimateKWh: 4190.15
  },
  {
    room: 'B010 - GF-B - DETS Sonapur - DETS',
    short: 'B010',
    powerAverage: 1.22,
    'elec/therm': 0.81,
    volume: '',
    elec: 61.22,
    hours: 50,
    therm: 75.44,
    estimateKWh: 4187.08
  },
  {
    room: 'B113 - 1F-B - DETS Sonapur - DETS',
    short: 'B113',
    powerAverage: 1.2,
    'elec/therm': 0.76,
    volume: '',
    elec: 59.96,
    hours: 50,
    therm: 79.36,
    estimateKWh: 4100.49
  },
  {
    room: 'B216 - 2F-B - DETS Sonapur - DETS',
    short: 'B216',
    powerAverage: 0.49,
    'elec/therm': 1.27,
    volume: '',
    elec: 59.56,
    hours: 121,
    therm: 46.96,
    estimateKWh: 4073.55
  },
  {
    room: 'B208 - 2F-B - DETS Sonapur - DETS',
    short: 'B208',
    powerAverage: 0.59,
    'elec/therm': 0.56,
    volume: '',
    elec: 58.48,
    hours: 99,
    therm: 103.52,
    estimateKWh: 3999.27
  },
  {
    room: 'A022 - GF-A - DETS Sonapur - DETS',
    short: 'A022',
    powerAverage: 0.59,
    'elec/therm': 0.69,
    volume: '',
    elec: 57.69,
    hours: 98,
    therm: 83.36,
    estimateKWh: 3945.18
  },
  {
    room: 'B115 - 1F-B - DETS Sonapur - DETS',
    short: 'B115',
    powerAverage: 0.59,
    'elec/therm': 0.78,
    volume: '',
    elec: 55.33,
    hours: 93,
    therm: 70.83,
    estimateKWh: 3783.98
  },
  {
    room: 'B004 - GF-B - DETS Sonapur - DETS',
    short: 'B004',
    powerAverage: 0.65,
    'elec/therm': 0.66,
    volume: '',
    elec: 53.64,
    hours: 83,
    therm: 81.28,
    estimateKWh: 3668.54
  },
  {
    room: 'B025 - GF-B - DETS Sonapur - DETS',
    short: 'B025',
    powerAverage: 0.68,
    'elec/therm': 0.71,
    volume: '',
    elec: 52.52,
    hours: 77,
    therm: 73.48,
    estimateKWh: 3591.87
  },
  {
    room: 'B205 - 2F-B - DETS Sonapur - DETS',
    short: 'B205',
    powerAverage: 0.62,
    'elec/therm': 0.65,
    volume: '',
    elec: 52.4,
    hours: 84,
    therm: 80.98,
    estimateKWh: 3583.39
  },
  {
    room: 'A007 - GF-A - DETS Sonapur - DETS',
    short: 'A007',
    powerAverage: 0.72,
    'elec/therm': 1.12,
    volume: '',
    elec: 50.99,
    hours: 71,
    therm: 45.4,
    estimateKWh: 3487.51
  },
  {
    room: 'B101 - 1F-B - DETS Sonapur - DETS',
    short: 'B101',
    powerAverage: 0.67,
    'elec/therm': 0.74,
    volume: '',
    elec: 50.96,
    hours: 76,
    therm: 68.87,
    estimateKWh: 3484.84
  },
  {
    room: 'B001 - GF-B - DETS Sonapur - DETS',
    short: 'B001',
    powerAverage: 2.54,
    'elec/therm': 1.71,
    volume: '',
    elec: 50.79,
    hours: 20,
    therm: 29.66,
    estimateKWh: 3473.56
  },
  {
    room: 'A011 - GF-A - DETS Sonapur - DETS',
    short: 'A011',
    powerAverage: 0.55,
    'elec/therm': 0.66,
    volume: '',
    elec: 50.45,
    hours: 92,
    therm: 76.34,
    estimateKWh: 3449.96
  },
  {
    room: 'B105 - 1F-B - DETS Sonapur - DETS',
    short: 'B105',
    powerAverage: 0.83,
    'elec/therm': 0.56,
    volume: '',
    elec: 47.42,
    hours: 57,
    therm: 84.8,
    estimateKWh: 3243.35
  },
  {
    room: 'B206 - 2F-B - DETS Sonapur - DETS',
    short: 'B206',
    powerAverage: 0.58,
    'elec/therm': 0.79,
    volume: '',
    elec: 47.17,
    hours: 82,
    therm: 59.44,
    estimateKWh: 3225.78
  },
  {
    room: 'B218 - 2F-B - DETS Sonapur - DETS',
    short: 'B218',
    powerAverage: 0.76,
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 46.56,
    hours: 61,
    therm: 0,
    estimateKWh: 3184.2
  },
  {
    room: 'B209 - 2F-B - DETS Sonapur - DETS',
    short: 'B209',
    powerAverage: 0.63,
    'elec/therm': 0.51,
    volume: '',
    elec: 45.42,
    hours: 72,
    therm: 88.57,
    estimateKWh: 3106.37
  },
  {
    room: 'B002 - GF-B - DETS Sonapur - DETS',
    short: 'B002',
    powerAverage: 1.65,
    'elec/therm': 0.85,
    volume: '',
    elec: 44.68,
    hours: 27,
    therm: 52.39,
    estimateKWh: 3055.76
  },
  {
    room: 'B108 - 1F-B - DETS Sonapur - DETS',
    short: 'B108',
    powerAverage: 0.73,
    'elec/therm': 0.95,
    volume: '',
    elec: 44.65,
    hours: 61,
    therm: 46.85,
    estimateKWh: 3053.43
  },
  {
    room: 'B103 - 1F-B - DETS Sonapur - DETS',
    short: 'B103',
    powerAverage: 0.74,
    'elec/therm': 0.79,
    volume: '',
    elec: 42.27,
    hours: 57,
    therm: 53.35,
    estimateKWh: 2890.8
  },
  {
    room: 'B018 - GF-B - DETS Sonapur - DETS',
    short: 'B018',
    powerAverage: 0.69,
    'elec/therm': 0.68,
    volume: '',
    elec: 42.11,
    hours: 61,
    therm: 61.99,
    estimateKWh: 2880.06
  },
  {
    room: 'B003 - GF-B - DETS Sonapur - DETS',
    short: 'B003',
    powerAverage: 0.72,
    'elec/therm': 0.36,
    volume: '',
    elec: 41.03,
    hours: 57,
    therm: 114.06,
    estimateKWh: 2805.86
  },
  {
    room: 'B117 - 1F-B - DETS Sonapur - DETS',
    short: 'B117',
    powerAverage: 0.62,
    'elec/therm': 0.78,
    volume: '',
    elec: 40.43,
    hours: 65,
    therm: 51.64,
    estimateKWh: 2765.17
  },
  {
    room: 'A107 - 1F-A - DETS Sonapur - DETS',
    short: 'A107',
    powerAverage: 0.54,
    'elec/therm': 1.12,
    volume: '',
    elec: 40.24,
    hours: 74,
    therm: 36.06,
    estimateKWh: 2751.97
  },
  {
    room: 'A104 - 1F-A - DETS Sonapur - DETS',
    short: 'A104',
    powerAverage: 0.69,
    'elec/therm': 0.81,
    volume: '',
    elec: 39.2,
    hours: 57,
    therm: 48.22,
    estimateKWh: 2681.05
  },
  {
    room: 'A009 - GF-A - DETS Sonapur - DETS',
    short: 'A009',
    powerAverage: 0.59,
    'elec/therm': 0.71,
    volume: '',
    elec: 39.12,
    hours: 66,
    therm: 54.87,
    estimateKWh: 2675.37
  },
  {
    room: 'A021 - GF-A - DETS Sonapur - DETS',
    short: 'A021',
    powerAverage: 0.63,
    'elec/therm': 0.65,
    volume: '',
    elec: 37.69,
    hours: 60,
    therm: 58.41,
    estimateKWh: 2577.43
  },
  {
    room: 'B007 - GF-B - DETS Sonapur - DETS',
    short: 'B007',
    powerAverage: 0.7,
    'elec/therm': 0.49,
    volume: '',
    elec: 37.02,
    hours: 53,
    therm: 74.92,
    estimateKWh: 2532.09
  },
  {
    room: 'A017 - GF-A - DETS Sonapur - DETS',
    short: 'A017',
    powerAverage: 0.53,
    'elec/therm': 0.9,
    volume: '',
    elec: 35.13,
    hours: 66,
    therm: 38.84,
    estimateKWh: 2402.7
  },
  {
    room: 'B107 - 1F-B - DETS Sonapur - DETS',
    short: 'B107',
    powerAverage: 0.7,
    'elec/therm': 0.46,
    volume: '',
    elec: 35.05,
    hours: 50,
    therm: 76.05,
    estimateKWh: 2397.36
  },
  {
    room: 'A121 - 1F-A - DETS Sonapur - DETS',
    short: 'A121',
    powerAverage: 0.57,
    'elec/therm': 0.83,
    volume: '',
    elec: 34.03,
    hours: 60,
    therm: 40.9,
    estimateKWh: 2327.06
  },
  {
    room: 'B016 - GF-B - DETS Sonapur - DETS',
    short: 'B016',
    powerAverage: 0.69,
    'elec/therm': 0.72,
    volume: '',
    elec: 33.2,
    hours: 48,
    therm: 46.07,
    estimateKWh: 2270.29
  },
  {
    room: 'A008 - GF-A - DETS Sonapur - DETS',
    short: 'A008',
    powerAverage: 0.43,
    'elec/therm': 0.84,
    volume: '',
    elec: 27.72,
    hours: 64,
    therm: 32.99,
    estimateKWh: 1895.44
  },
  {
    room: 'A105 - 1F-A - DETS Sonapur - DETS',
    short: 'A105',
    powerAverage: 0.49,
    'elec/therm': 1,
    volume: '',
    elec: 26.79,
    hours: 55,
    therm: 26.71,
    estimateKWh: 1832.05
  },
  {
    room: 'B123 - 1F-B - DETS Sonapur - DETS',
    short: 'B123',
    powerAverage: 0.7,
    'elec/therm': 0.59,
    volume: '',
    elec: 26.64,
    hours: 38,
    therm: 45.25,
    estimateKWh: 1822.2
  },
  {
    room: 'B220 - 2F-B - DETS Sonapur - DETS',
    short: 'B220',
    powerAverage: 0.87,
    'elec/therm': '#N/A',
    volume: '',
    elec: 26.08,
    hours: 30,
    therm: '#N/A',
    estimateKWh: 1783.9
  },
  {
    room: 'B104 - 1F-B - DETS Sonapur - DETS',
    short: 'B104',
    powerAverage: 0.51,
    'elec/therm': 0.64,
    volume: '',
    elec: 22.76,
    hours: 45,
    therm: 35.37,
    estimateKWh: 1556.57
  },
  {
    room: 'A110 - 1F-A - DETS Sonapur - DETS',
    short: 'A110',
    powerAverage: 1.37,
    'elec/therm': 0.91,
    volume: '',
    elec: 20.54,
    hours: 15,
    therm: 22.52,
    estimateKWh: 1404.67
  },
  {
    room: 'A020 - GF-A - DETS Sonapur - DETS',
    short: 'A020',
    powerAverage: 1.1,
    'elec/therm': 0.8,
    volume: '',
    elec: 16.56,
    hours: 15,
    therm: 20.79,
    estimateKWh: 1132.55
  },
  {
    room: 'A019 - GF-A - DETS Sonapur - DETS',
    short: 'A019',
    powerAverage: 0.95,
    'elec/therm': 1.36,
    volume: '',
    elec: 11.39,
    hours: 12,
    therm: 8.4,
    estimateKWh: 779.17
  },
  {
    room: 'B116 - 1F-B - DETS Sonapur - DETS',
    short: 'B116',
    powerAverage: 0.15,
    'elec/therm': 3.64,
    volume: '',
    elec: 10.77,
    hours: 71,
    therm: 2.96,
    estimateKWh: 736.57
  },
  {
    room: 'B011 - GF-B - DETS Sonapur - DETS',
    short: 'B011',
    powerAverage: 0.13,
    'elec/therm': 7.34,
    volume: '',
    elec: 8.22,
    hours: 64,
    therm: 1.12,
    estimateKWh: 562.44
  },
  {
    room: 'B217 - 2F-B - DETS Sonapur - DETS',
    short: 'B217',
    powerAverage: '#N/A',
    'elec/therm': 2.22,
    volume: '',
    elec: 6.78,
    hours: '#N/A',
    therm: 3.05,
    estimateKWh: 463.82
  },
  {
    room: 'B012 - GF-B - DETS Sonapur - DETS',
    short: 'B012',
    powerAverage: '#N/A',
    'elec/therm': 0.66,
    volume: '',
    elec: 4.86,
    hours: '#N/A',
    therm: 7.38,
    estimateKWh: 332.38
  },
  {
    room: 'A103 - 1F-A - DETS Sonapur - DETS',
    short: 'A103',
    powerAverage: '#N/A',
    'elec/therm': 1.24,
    volume: '',
    elec: 4.53,
    hours: '#N/A',
    therm: 3.65,
    estimateKWh: 309.88
  },
  {
    room: 'B008 - GF-B - DETS Sonapur - DETS',
    short: 'B008',
    powerAverage: '#N/A',
    'elec/therm': 1.08,
    volume: '',
    elec: 3.07,
    hours: '#N/A',
    therm: 2.85,
    estimateKWh: 209.89
  },
  {
    room: 'B224 - 2F-B - DETS Sonapur - DETS',
    short: 'B224',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.63,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 42.88
  },
  {
    room: 'A224 - 2F-A - DETS Sonapur - DETS',
    short: 'A224',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.61,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 41.58
  },
  {
    room: 'B222 - 2F-B - DETS Sonapur - DETS',
    short: 'B222',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.6,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 40.97
  },
  {
    room: 'B225 - 2F-B - DETS Sonapur - DETS',
    short: 'B225',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.54,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 37.14
  },
  {
    room: 'A214 - 2F-A - DETS Sonapur - DETS',
    short: 'A214',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.54,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 36.66
  },
  {
    room: 'B221 - 2F-B - DETS Sonapur - DETS',
    short: 'B221',
    powerAverage: '#N/A',
    'elec/therm': 8.73,
    volume: '',
    elec: 0.52,
    hours: '#N/A',
    therm: 0.06,
    estimateKWh: 35.84
  },
  {
    room: 'A218 - 2F-A - DETS Sonapur - DETS',
    short: 'A218',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.49,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 33.31
  },
  {
    room: 'A210 - 2F-A - DETS Sonapur - DETS',
    short: 'A210',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.45,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 30.43
  },
  {
    room: 'A219 - 2F-A - DETS Sonapur - DETS',
    short: 'A219',
    powerAverage: '#N/A',
    'elec/therm': 2.42,
    volume: '',
    elec: 0.44,
    hours: '#N/A',
    therm: 0.18,
    estimateKWh: 29.75
  },
  {
    room: 'A226 - 2F-A - DETS Sonapur - DETS',
    short: 'A226',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.41,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 28.31
  },
  {
    room: 'A208 - 2F-A - DETS Sonapur - DETS',
    short: 'A208',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.4,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 27.15
  },
  {
    room: 'A217 - 2F-A - DETS Sonapur - DETS',
    short: 'A217',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.34,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 23.25
  },
  {
    room: 'A023 - GF-A - DETS Sonapur - DETS',
    short: 'A023',
    powerAverage: '#N/A',
    'elec/therm': 0.65,
    volume: '',
    elec: 0.28,
    hours: '#N/A',
    therm: 0.43,
    estimateKWh: 19.22
  },
  {
    room: 'B114 - 1F-B - DETS Sonapur - DETS',
    short: 'B114',
    powerAverage: '#N/A',
    'elec/therm': '#DIV/0!',
    volume: '',
    elec: 0.28,
    hours: '#N/A',
    therm: 0,
    estimateKWh: 18.94
  },
  {
    room: 'A205 - 2F-A - DETS Sonapur - DETS',
    short: 'A205',
    powerAverage: '#N/A',
    'elec/therm': '#N/A',
    volume: '',
    elec: 0.27,
    hours: '#N/A',
    therm: '#N/A',
    estimateKWh: 18.53
  }
];
